/* 🤖 this file was generated by svg-to-ts */
export const IconBigBoldWinkelRechts: {
    name: 'big-bold-winkel-rechts';
    data: string;
} = {
    name: 'big-bold-winkel-rechts',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M36 127.5a7.5 7.5 0 0 1-5.3-12.8L81.39 64 30.7 13.3A7.5 7.5 0 0 1 41.3 2.7l53.18 53.17a11.52 11.52 0 0 1 0 16.26L41.3 125.3a7.44 7.44 0 0 1-5.3 2.2m47.87-61"/></svg>`,
};
